import serverPackage from '../package.json'

export async function createBrowserReadModelAdapter({ featureOptions } = {}) {
  const packageUrl = `/libs/read-model-browser/index.js?v=${encodeURIComponent(serverPackage.dependencies['@aeppic/read-model-browser'])}`
  // Production requires OPFS; memory storage is an explicit caller option only.
  const { createBrowserReadModel } = await import(packageUrl)
  const adapter = await createBrowserReadModel({
    server: window.location.origin,
    deferSync: true,
    syncIdleMs: featureOptions?.syncIdleMs,
    // Reader workers of the database owner: true, false or { enabled, count }.
    readers: featureOptions?.readers,
    // Which public trees the local model holds (system, apps; include,
    // exclude, prune per tree). Unset: the package default.
    startupProfiles: featureOptions?.startupProfiles,
    onProgress(progress) {
      window.dispatchEvent(new CustomEvent('aeppic:local-read-model-progress', { detail: progress }))
    },
    onError(error) {
      // Scope coverage remains authoritative: a failed refresh must not disable
      // unrelated, validated apps/system data already committed in OPFS.
      console.warn('Local read-model synchronization failed; uncovered reads use the server', error)
    },
  })
  return adapter
}
